import React from 'react';
import { CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { finalCtaCopy, offer } from '../data/content';
interface FinalCtaCopy {
  title: string;
  subtitle: string;
  summary: string;
  cta: string;
}
interface FinalCtaProps {
  copy?: FinalCtaCopy;
}
export function FinalCta({
  copy = finalCtaCopy
}: FinalCtaProps) {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-68" data-mp="1jclja7depdpu">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-69" data-mp="1jb22mfnu90nj">
        <div className="mx-auto max-w-3xl text-center" data-id="element-70" data-mp="1ed0lw1dvxdf8">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-71" data-mp="1t2yd6q742j8n">
            {copy.title}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-blue-900/75" data-id="element-72" data-mp="1o56ar28ubeq7">{copy.subtitle}</p>
        </div>

        <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-white p-6 text-center shadow-lg ring-2 ring-blue-600 sm:p-8" data-id="element-73" data-mp="224ee87c1d907">
          <h3 className="text-lg font-extrabold uppercase leading-snug tracking-tight text-slate-900" data-id="element-74" data-mp="1x2gn6qxe99wp">
            {offer.name}
          </h3>
          <p className="mt-1 font-semibold text-blue-600" data-id="element-75" data-mp="s45ts71gznwc">{copy.summary}</p>
          <p className="mt-5 text-5xl font-extrabold tracking-tight text-slate-900" data-id="element-76" data-mp="x3s86jt1ba6q">
            {offer.price}
            <span className="ml-2 text-lg font-semibold text-blue-900/55" data-id="element-77" data-mp="122loejzphfal">{offer.currency}</span>
          </p>
          <div className="mt-6" data-id="element-78" data-mp="16501engp1kty">
            <CtaButton size="lg" className="w-full" data-id="element-79" data-mp="163xeeqmhs2jb">
              {copy.cta}
            </CtaButton>
          </div>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-80" data-mp="1b1grhn7ge99o">
            <li className="inline-flex items-center gap-1.5" data-id="element-81" data-mp="1kt3c2a5olkp3">
              <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-82" data-mp="1ksl5ajle7o2x" /> Accès immédiat
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-83" data-mp="1pqcz5j5llk9r">
              <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-84" data-mp="1tv2qcupbaaoc" /> Paiement
              unique
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-85" data-mp="3qsktodp4nwp4">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-86" data-mp="3lwnc6424okar" /> Garantie
              de 7 jours
            </li>
          </ul>
        </div>
      </div>
    </section>;
}